import { CustomerOrderListWithTable } from '../../../../../components/CustomerOrderList/CustomerOrderListWithTable';
import {
  EmployeeOrdersBreadcrumb,
  EmployeeOrdersNavi,
  EmployeeOrdersWrapper,
} from '../../../../../components/EmployeeOrdersWrapper/EmployeeOrdersWrapper.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useAuth } from '../../../AuthProvider';
import { useLoaderData } from 'react-router-dom';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import type { CustomerOrdersResponse } from '../../../../../generated/api/customerOrdersResponse';

export const PendingReviewsPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, resultCountAggregations, total } = useLoaderData() as CustomerOrdersResponse;

  const { search, status } = useSearchParams<{
    offset?: string;
    order?: string;
    search?: string;
    status?: string;
    sort?: string;
  }>();

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.Y29L(orderRequestsMsg)]);

  return (
    <EmployeeOrdersWrapper>
      <EmployeeOrdersBreadcrumb />
      <EmployeeOrdersNavi />
      <Grid>
        <CustomerOrderListWithTable
          basePath={paths.EMPLOYEE_PENDING_REVIEW_ORDER}
          customerOrders={searchResults}
          aggregations={resultCountAggregations}
          loading={false}
          totalItems={total}
          status={status}
          searchQuery={search}
          authenticatedUser={authenticatedUser}
          noFilters={true}
        />
        <p>
          <strong>{t.FZU3(`Can't you see your order here?`)}</strong>{' '}
          {t.QZZR('If you just placed it, no worries. The order will appear here with a little delay.')}
        </p>
      </Grid>
    </EmployeeOrdersWrapper>
  );
};
